import { ReactNode } from "react";

interface Props {
  title?: string;
  children: ReactNode;
}

export function EditorialNote({ title, children }: Props) {
  return (
    <aside className="border border-ruleline bg-parchment-50 px-6 py-5">
      {title ? <div className="text-smallcaps mb-2 text-oxblood-500">{title}</div> : null}
      <div className="font-serif text-dek italic text-warmgray-500">{children}</div>
    </aside>
  );
}
